import React, { useMemo } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

const TopicChart = props => {
  const { data, barChartDefaultData } = props;


  const chartOptions = useMemo(() => {

    const option = {
      exporting: { enabled: false },
      chart: {
        type: 'column',
        margin: [50, 0, 100, 60]
      },
      tooltip: {
        shared: true,
        useHTML: true,
        followPointer: true,
        outside: true,
        backgroundColor: 'none',
        borderWidth: 0,
        shadow: false,
        positioner: function (labelWidth, labelHeight, point) {
          return {
            x: point.plotX + this.chart.plotLeft - labelWidth / 2,
            y: point.plotY + this.chart.plotTop - labelHeight
          };
        },
        tooltip: {
          outside: true,
          useHTML: true,
          backgroundColor: 'transparent',
          borderWidth: 0,
          shadow: false,
          padding: 0,
        },
        title: {
          text: ''
        },
        legend: {
          y: 20
        },
        xAxis: {
          labels: {
            useHTML: true,
            style: {
              color: '#6E7686',
              fontSize: '12px',
              whiteSpace: 'normal',
              width: '60px'
            }
          }
        },
        yAxis: {
          labels: {
            style: {
              color: '#6E7686',
              fontSize: '12px'
            }
          },
          title: {
            text: 'Impact Score',
            align: 'middle',
            offset: 50,
            rotation: -90,
            y: 0,
            style: {
              fontWeight: '600'
            }
          }
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            events: {
              mouseOut() {
                this.chart.tooltip.hide(0);
              }
            }
          }
        },
        series: []
      }
    };
    const extraConfig = {
      tooltip: {
        positioner: function (labelWidth, labelHeight, point) {
          const chart = this.chart;
          const padding = 12;
          const x = chart.plotLeft + point.plotX - labelWidth / 2;
          const isNegative = point.y < 0;
          const y = isNegative
            ? chart.plotTop + point.plotY + padding
            : chart.plotTop + point.plotY - labelHeight - padding;

          return { x, y };
        },
        formatter: function () {
          const value = Highcharts.numberFormat(this.y, 2);
          return `
          <div style="
            background: #1e222c;
            color: #fff;
            padding: 12px 18px;
            border-radius: 14px;
            font-size: 14px;
            box-shadow: 0 4px 14px rgba(0,0,0,0.25);
            display: flex;
            flex-direction: column;
            gap: 6px;
            pointer-events: none;
          ">
            <div style="font-size: 14px; font-weight: 600;">${this.key}</div>
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <div style="display: flex; align-items: center; gap: 6px;">
                <div style="
                  width: 10px; height: 10px;
                  background: ${value < 0 ? '#E2646C' : '#AEE2B7'};
                "></div>
                <span style="opacity: 0.8;">${'Impact Score'}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              </div>
              <span style="font-weight: 600;">${value}</span>
            </div>
          </div>
          <div style="
            width: 0; height: 0; margin: 0 auto;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 12px solid #1e222c;
          "></div>
        `;
        }
      },
      xAxis: {
        categories: data?.data?.map(e => e?.topic_label) || [],
        labels: {
          formatter: function () {
            return `<span class="x-axis-label">${this.value}</span>`;
          },
        }
      },
      series: [
        {
          name: data?.title,
          data: data?.data?.map(e => Number(e?.impact_score)) || [],
          colors: data?.data?.map(e => ({
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, Number(e?.impact_score) < 0 ? '#E77C83' : '#b4f5c1ff'],
              [
                1,
                Highcharts.color(Number(e?.impact_score) < 0 ? '#E77C83' : '#b4f5c1ff')
                  .brighten(-0.3)
                  .get()
              ]
            ]
          })),
          colorByPoint: true
        }
      ]
    }
    return Highcharts.merge(barChartDefaultData || option, extraConfig)

  }, [data])
  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default TopicChart;
